// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__tOZGY","full":"loader_full__yP-mv","ldsRipple":"loader_ldsRipple__+O1EX","lds-ripple":"loader_lds-ripple__Wt+Gl"};